import type { CreatureState, Stage } from '@/domain/creature/types';
import { ELDER_HEALTH_PENALTY } from './constants';

const clamp = (n: number, lo: number, hi: number): number => Math.min(hi, Math.max(lo, n));

/**
 * Saúde derivada — soma de penalidades aplicadas a uma base 100.
 * Sempre em [0..100]. Não persiste no save (é função pura do state).
 */
export function computeHealth(s: CreatureState, stage: Stage): number {
  const hungerPenalty = s.hunger < 30 ? (30 - s.hunger) * 0.6 : 0;
  const happinessPenalty = s.happiness < 30 ? (30 - s.happiness) * 0.5 : 0;
  const poopPenalty = s.poopCount * 4;
  const weightPenalty =
    s.weight < 20 ? (20 - s.weight) * 0.8 : s.weight > 80 ? (s.weight - 80) * 0.6 : 0;
  const sickPenalty = s.sick ? 30 : 0;
  const elderPenalty = stage === 'elder' ? ELDER_HEALTH_PENALTY : 0;
  const raw = 100 - hungerPenalty - happinessPenalty - poopPenalty - weightPenalty - sickPenalty - elderPenalty;
  return clamp(Math.round(raw), 0, 100);
}
